// @ts-nocheck

import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import CodeOutlined from '@ant-design/icons/CodeOutlined'

export default {
  DatabaseOutlined,
CodeOutlined
}
    